import {
  IsBoolean,
  IsDefined,
  IsInt,
  IsNotEmpty,
  IsPositive,
  IsString,
  IsUUID,
  Length,
  Matches,
  Max,
  MaxLength,
  Min,
  ValidateNested,
} from 'class-validator';
import { Exclude, Expose, Type } from 'class-transformer';
import generateId from '@/utils/random';
import { validateSyncOrThrow } from '@/utils/validations';
import { BankAccount } from '@/api/payment-orders';

export class Transaction {
  @IsDefined()
  @IsUUID()
  @Exclude()
  id!: string;

  @IsDefined()
  @ValidateNested()
  @Type(() => BankAccount)
  @Expose()
  creditor!: BankAccount;

  @IsDefined()
  @ValidateNested()
  @Type(() => BankAccount)
  @Expose()
  debtor!: BankAccount;

  @IsDefined()
  @IsInt()
  @IsPositive()
  @Min(1)
  @Max(99999999999999)
  @Expose()
  amount!: number;

  @IsDefined()
  @IsString()
  @IsNotEmpty()
  @Length(4)
  @Matches(/^HR\d{2}$/)
  @Exclude()
  model!: string;

  @IsDefined()
  @IsString()
  @Length(0, 31)
  @Exclude()
  ref!: string;

  @IsDefined()
  @IsString()
  @IsNotEmpty()
  @MaxLength(140)
  @Expose()
  description!: string;

  @IsBoolean()
  @Exclude()
  isScanned!: boolean;

  @Expose({ toPlainOnly: true })
  get reference() {
    return `${this.model}${this.ref}`;
  }

  static from(debtor: BankAccount, creditor: BankAccount, amount: number, {
    model = 'HR99', ref = '', description = 'Račun', isScanned = false,
  } = {}) {
    const transaction = new Transaction();

    transaction.id = generateId();
    transaction.debtor = debtor;
    transaction.creditor = creditor;
    transaction.amount = amount;
    transaction.model = model;
    transaction.ref = ref;
    transaction.description = description;
    transaction.isScanned = isScanned;

    validateSyncOrThrow(transaction);

    return transaction;
  }

  static default(): Transaction {
    const transaction = new Transaction();

    transaction.id = generateId();
    transaction.model = 'HR99';

    return transaction;
  }
}
